import DailyOperations from '../../../../schrockenAdmin/settings/dailyOperations';

const DailyOperationsDashboard = (props) => {
  return <DailyOperations {...props} />;
};

export default DailyOperationsDashboard;
